module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('shop-select', {
    attrs: {
      "distributors": ""
    },
    on: {
      "update": _vm.storeChange,
      "init": _vm.initChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleAddSalesman
    }
  }, [_vm._v("添加导购员")])], 1)], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "导购员列表",
      "name": "admin"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "salesman_name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "child_count",
      "label": "会员数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.child_count > 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.searchMembers(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.child_count))]) : _c('span', [_vm._v("0")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-value": "true",
            "inactive-value": "false",
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.defaultSwitchChange(scope.row)
            }
          },
          model: {
            value: (scope.row.is_valid),
            callback: function($$v) {
              _vm.$set(scope.row, "is_valid", $$v)
            },
            expression: "scope.row.is_valid"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "所属店铺"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.handleUpdateSelasman(scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.handleDeleteSelasman(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加/编辑导购员",
      "visible": _vm.dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属店铺"
    }
  }, [_c('shop-select', {
    attrs: {
      "distributors": "",
      "shop-id-default": _vm.shopname
    },
    on: {
      "update": _vm.addSelectStoreChange,
      "init": _vm.initChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "193px"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导购员姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "193px"
    },
    attrs: {
      "placeholder": "请输入导购员姓名"
    },
    model: {
      value: (_vm.form.salesman_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesman_name", $$v)
      },
      expression: "form.salesman_name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddSelasman
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-679d00e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-679d00e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/salesman.vue
// module id = 2790
// module chunks = 0